import type { FaireProductEntity } from "../../entity_types/product";

export const p_myyg57tuhn: FaireProductEntity = {
  token: "p_myyg57tuhn",
  type: "product",
  name: "Hand Crème - Fleurir",
  brandToken: "b_phyk4zwbt3",
  brandName: "Mienne",
  imageUrl:
    "https://cdn.faire.com/fastly/dc2c0748555d1bf824011b2c6228514682fb826e86e4bf479d4c898fdb3d94d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2db15d9aff5d0d8852fe33b82b3a2da1688e4e4110475d300249da71d75cc29.jpeg",
    "https://cdn.faire.com/fastly/6288a8a651f12949ab6cac892beff8fff569d3eac7d8d7575e82be7687858c19.jpeg",
    "https://cdn.faire.com/fastly/1394eeba40eb272c6048b771fd972e27b3ce0dfb28b9a1bf5ead5a8528529daf.jpeg",
    "https://cdn.faire.com/fastly/db4b591266c00bf9dd8493c7ec0234aca6008528424bcc2bf21348b9e0976edd.jpeg",
  ],
  priceDollars: 12.25,
  description:
    "A cashmere-soft hand cream that deeply hydrates, smooths, and rejuvenates for lasting softness. Botanical oils and butters blend with Peptides, Niacinamide, Ceramides, and Multi-Weight Hyaluronic Acid to refine and restore, while mood-shifting adaptogens and two signature scents heighten connection through the senses.\n",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:32:35.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
